module.exports = __webpack_public_path__ + "img/background.b1fa3511.jpg";